"use client";

import { usePath, useRouter, useSearch } from "@packages/framework";
import { useCallback } from "react";

import type { HallowQueries } from "../lib/types/hallowQueries.types";

export const useRedirectToAuth = () => {
  const router = useRouter();
  const pathname = usePath();
  const searchParams = useSearch();

  return useCallback(
    async ({
      newWindow = false,
      queries = {},
    }: {
      newWindow?: boolean;
      queries?: HallowQueries;
    } = {}) => {
      const loginURLSearchParams = new URLSearchParams();
      if (queries) {
        for (const [key, val] of Object.entries(queries)) {
          loginURLSearchParams.set(key, val);
        }
      }
      const currentSearch = searchParams?.toString();
      const fullPath = currentSearch
        ? `${pathname}?${currentSearch}`
        : pathname;
      const url = `/login?redirect=${encodeURIComponent(fullPath)}&${loginURLSearchParams.toString()}`;
      if (newWindow) {
        window.open(url);
      } else {
        return router.push(url);
      }
    },
    [pathname, router, searchParams?.toString()],
  );
};
